export function splitExt(path: string): [string, string] {
  const parts = path.split('.')
  if (parts.length > 1) {
    const head = parts.slice(0, parts.length - 1).join('.')
    return [head, parts[parts.length - 1]]
  } else {
    return [path, '']
  }
}
